import React from "react";

const About = () => {
  return (
    <div className="container">
      <h2>About Us</h2>
      <p className="lead">
        This is an app created to manage contacts. It could be seen and used as
        a backup for your contacts.
        <b className="text-secondary small ml-5">...Version 1.0.0</b>
      </p>
    </div>
  );
};
export default About;
